import React, { useState } from "react";
import Carousel from "./Carousel";
import { CalendarDays } from "lucide-react";

const Schedule = () => {
  const [activeTab, setActiveTab] = useState("workshop");
  const [showModal, setShowModal] = useState(false);

  const scheduleImages = {
    workshop: require("../image/workshop day.jpg"),
    industry: require("../image/industry day.jpg"),
    day1: require("../image/conf day 1.jpg"),
    day2: require("../image/conf day 2.jpg"),

  // PAPER PRESENTATION SCHEDULE (5 images)
    paper: [
      require("../image/paper1.jpg"),
      require("../image/paper2.jpg"),
      require("../image/paper3.jpg"),
      require("../image/paper4.jpg"),
      require("../image/paper5.jpg"),
    ],
  };

  return (
    <>
      <Carousel img="bg4.png" />
      <hr />
      <div className="container py-5">
        <h1 className="text-center mb-4">Schedule</h1>
        <div className="text-center mb-4">
          <button
            className="blink-btn btn btn-danger fw-bold px-4 py-2"
            onClick={() => setShowModal(true)}
          >
            🚍 Shuttle Bus Pickup Points & Timings
          </button>
        </div>

        {/* ⭐⭐ NEW: MODAL ⭐⭐ */}
        {showModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal">
              <h3 className="text-center fw-bold mb-3">
                🚍 Shuttle Bus Pickup Points & Timings
              </h3>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Venue</th>
                    <th>Time</th>
                    <th>Pick-up Point</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>Golden Tulip</td><td>6:30 AM</td><td>At the hotel</td></tr>
                  <tr><td>Starlite Suites</td><td>6:45 AM</td><td>At the hotel</td></tr>
                  <tr><td>Republic Inn</td><td>6:55 AM</td><td>Opposite side of the Road</td></tr>
                  <tr><td>Hotel Mount View Cowforts</td><td>7:00 AM</td><td>Nearest Main Road</td></tr>
                  <tr><td>PVK Residency + Lemon Tree</td><td>7:05 AM</td><td>Under Flyover / Signal</td></tr>
                  <tr><td>Vasavi Residency</td><td>7:10 AM</td><td>Ramamurthy Cafe</td></tr>
                  <tr><td>MGM Ground, Srikalahasti</td><td>7:45 AM</td><td>At the hotel</td></tr>
                  <tr><td>IIT Tirupati Campus</td><td>8:15 AM</td><td>—</td></tr>
                </tbody>
              </table>

              <div className="text-center mt-3">
                {/* Replace image names after upload */}

                <img
                  src={require("../image/bus_map.jpeg")}
                  alt="Bus Route Map"
                  className="img-fluid rounded mb-3"
                />

                <a
                  href="https://maps.app.goo.gl/zLwLRW8vSZNcKXEW9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary mt-2"
                >
                  📍 Open Route in Google Maps
                </a>
              </div>

              <div className="text-center mt-4">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
        {/* IMPORTANT DATES */}
        <div className="container text-center my-4 p-1">
          <h2 className="text-2xl font-bold text-center mt-2 mb-4">
            <CalendarDays className="text-primary" size={30} /> Important Dates
            <hr className="brW" />
          </h2>

          <div className="row">
            <div className="col-md-4">
              <div className="dates">
                <hr className="brMB" />
                <h4>Workshop Day</h4>
                <hr className="brW" />
                <p><b>30th November 2025</b></p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="dates">
                <hr className="brMB" />
                <h4>Industry Day</h4>
                <hr className="brW" />
                <p><b>1st December 2025</b></p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="dates">
                <hr className="brMB" />
                <h4>Conference Days</h4>
                <hr className="brW" />
                <p><b>2nd–3rd December 2025</b></p>
              </div>
            </div>
          </div>
        </div>

         {/* RED BOLD NOTES */}
          <div className="mb-4 text-center">
            <p className="fw-bold text-danger">
              "Note: All Workshop participants are required to carry their own laptop."
            </p>
            <p className="fw-bold text-danger">
              "Note: All posters must be displayed at the designated place (LHC Ground Floor) from Industry day onwards. </p>
             <p className="fw-bold text-danger"> The evaluation of formal poster presentation will happen on Dec 2nd"
            </p>
          </div>

        {/* DETAILED SCHEDULE */}
        <div className="container mt-5">
          <h3 className="text-center mb-4">Detailed Schedule</h3>

          {/* TAB BUTTONS */}
          <div className="d-flex justify-content-center gap-2 flex-wrap mb-4">
            <button
              className={`btn ${
                activeTab === "workshop" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setActiveTab("workshop")}
            >
              Workshop Day
            </button>

            <button
              className={`btn ${
                activeTab === "industry" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setActiveTab("industry")}
            >
              Industry Day
            </button>

            <button
              className={`btn ${
                activeTab === "day1" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setActiveTab("day1")}
            >
              Conference Day 1
            </button>

            <button
              className={`btn ${
                activeTab === "day2" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setActiveTab("day2")}
            >
              Conference Day 2
            </button>

            <button
              className={`btn ${
                activeTab === "paper" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setActiveTab("paper")}
            >
              Paper Presentation Schedule
            </button>
          </div>

          {/* DISPLAY CONTENT */}
          <div className="text-center">

            {/* SINGLE IMAGE TABS */}
            {activeTab !== "paper" && (
              <img
                src={scheduleImages[activeTab]}
                alt={`${activeTab} schedule`}
                className="schedule-img rounded shadow"
              />
            )}

            {/* MULTI-IMAGE PAPER SCHEDULE */}
            {activeTab === "paper" && (
              <div className="paper-container">
                {scheduleImages.paper.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`paper schedule ${index + 1}`}
                    className="paper-img"
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Schedule;